import UserProfile from './UserProfile';
import RightSidebarUserProfile from './RightSidebarUserProfile/RightSidebarUserProfile';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';

export default ColumnsContent(UserProfile, RightSidebarUserProfile);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/UserProfile/Content.js